import { create } from "zustand";

const useStore = create((set) => ({
  // user:null,
  // setUser: (user) => set({user}),
  // clearUser: () => setUser({user: null}),

  patients: [],
  setPatients: (patients) => set({ patients }),
  patient: null,
  setPatient: (patient) => set({ patient: patient }),
  fetchPatients: async () => {
    const token = localStorage.getItem("token");
    console.log("Fetching patients...");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patients`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      console.log("Patient List ", data);
      set({ patients: data });
    } catch (err) {
      console.log("Error fetching patients ", err);
    }
  },
  fetchPatientByID: async (id) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patients/id/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Unable to load patient");
      console.log("Patient ID ", data);
      set({ patient: data });
      return data;
    } catch (err) {
      console.log("Error fetching patient details");
      return null;
    }
  },
  fetchPatientByUID: async (uid) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patients/uid/${uid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Unable to load patient");
      console.log("Patient ID ", data);
      set({ patient: data });
      return data;
    } catch (err) {
      console.log("Error fetching patient details");
      return null;
    }
  },
  patientHistory: [],
  fetchPatientHistory: async (patientId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patientHistory/getAllSessions/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      console.log("Patient History ", data);
      set({ patientHistory: data });
    } catch (err) {
      console.log("Error fetching patient history ", err);
    }
  },
  clinician: null,
  setClinician: (clinician) => set({ clinician: clinician }),
  fetchClinician: async (clinicianId) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/clinicians/${clinicianId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Unable to load clinician");
      console.log("Data ", data);
      set({ clinician: data });
      return data;
    } catch (err) {
      console.log("Error fetching Clinician details ", err);
      return null;
    }
  },
}));

export default useStore;
